import { useState } from "react";
import { clearSettings, loadSettings, type Settings } from "./api";
import { Dashboard } from "./Dashboard";
import { Login } from "./components/Login";

export default function App() {
    const [settings, setSettings] = useState<Settings | null>(loadSettings());

    if (!settings) return <Login onSave={setSettings} />;
    return (
        <Dashboard
            settings={settings}
            onLogout={() => {
                clearSettings();
                setSettings(null);
            }}
        />
    );
}
